import { useState, useEffect } from "react";

export default function PopupCall() {
  const [show, setShow] = useState(true);

  useEffect(() => {
    const i = setInterval(() => setShow(true), 3000);
    return () => clearInterval(i);
  }, []);

  if (!show) return null;

  return (
    <div id="popupCallContainer" className="popup-call-container" style={{ display: 'flex' }}>
      <div className="popup-call-card">
        <button className="popup-cancel" id="popupCancel" aria-label="Close" onClick={() => setShow(false)}>×</button>
        <p><i className="fas fa-user-headset" style={{ color: '#ff6b00', marginRight: '8px' }}></i> <strong>Connect with expert technician</strong></p>
        <div className="popup-actions">
          <a href="tel:8863093448" className="btn-call-now"><i className="fas fa-phone-alt"></i>Call Now</a>
          <button className="btn-remind-later" id="remindLater">Later</button>
        </div>
      </div>
    </div>
  );
}
